export enum DistanceUnit {
  kiloMeter = 'km',
  mile = 'mile',
}
